import type React from 'react';
import useSectionManager from 'src/app/hooks/use-section-manager';
import type { ContentData } from 'app/ui/components/molecules/content-item-areas-wrapper';
import SlideTimer from './index';

export interface SlideTimerContainerProps {
  endSeconds: number;
  timerId: string;
  isPresenterView?: boolean;
  sectionData: ContentData;
}

const SlideTimerContainer: React.FC<SlideTimerContainerProps> = ({
  endSeconds,
  timerId,
  isPresenterView = false,
  sectionData,
}) => {
  const hasWorkOrRestTime = !!sectionData.workTime || !!sectionData.restTime;
  const sectionConfig = hasWorkOrRestTime
    ? {
        workTime: sectionData.workTime || 0,
        restTime: sectionData.restTime || 0,
        rounds: sectionData.rounds || 1,
      }
    : undefined;

  const { reset, currentSectionState } = useSectionManager({
    timerId,
    sectionConfig,
    finalDuration: endSeconds || 0,
  });

  const isWorkTime = currentSectionState.currentSection === 'Work';
  const progressPercentage = hasWorkOrRestTime ? 100 - currentSectionState.sectionProgress : 100;

  return (
    <SlideTimer
      isPresenterView={isPresenterView}
      countdownTime={currentSectionState.countdownTime}
      isWorkTime={isWorkTime}
      currentRound={currentSectionState.currentRound + 1}
      totalRounds={sectionData.rounds || 1}
      currentSection={currentSectionState.currentSection}
      hasWorkRestSections={hasWorkOrRestTime}
      progressPercentage={progressPercentage}
      onReset={reset}
    />
  );
};

export default SlideTimerContainer;
